import { RefObject } from 'react';

import { defaultScrollAreaHeight } from './constants';

/**
 * Get the scroll area height for the list of selectable statements. This is set up so that the
 * StatementSelector can expand to fill the vertical space in the viewport, with some padding
 * below it.
 * @param {RefObject<HTMLDivElement>} containerRef a ref for the outermost div in StatementSelector
 * @param {number} nonScrollAreaHeight the height of the content within the StatementSelector that
 * is not created by the scroll area
 * @return {number} the scroll area height
 */
export const getScrollAreaHeight = (
    containerRef: RefObject<HTMLDivElement>,
    nonScrollAreaHeight: number,
): number => {
    if (!containerRef.current) {
        return defaultScrollAreaHeight;
    }

    const vh = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0,
    );
    const { top } = containerRef.current.getBoundingClientRect();
    const verticalSpace = vh - top;
    const bottomPadding = 60;

    return verticalSpace - nonScrollAreaHeight - bottomPadding;
};
